import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';

@Component
export default class GridLinkPriorityCombinedComponent extends Vue {
    @Prop({ default: false }) public priority: boolean;
    @Prop({ default: '' }) public text: string;
    @Prop({ default: '' }) public url: string;
}
